import React, {Component} from "react"

import adminTracking from "@irati-tracking/admin"
import {getThumbnailImage} from "@irati/utils/images"
import HR from "@irati/ui/src/Layout/Hr"
import Toggle from "@irati/ui/src/FormItem/Toggle"
import {Deal} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import DescriptionModal from "../DealDescription"

import ToggleWrapper from "../styled/ToggleWrapper"
import ThumbnailImage from "../styled/ThumbnailImage"
import {StyledH5, StyledIconBtn} from "./styled"

interface Props {
  deal: Deal,
  blacklisted: boolean,
  handleToggle: (uuid: string) => Promise<void>
}
interface State {
  showModal: boolean,
  load: Promise<void> | null
}

export default class DealListItem extends Component<Props, State> {
  static defaultProps = {
    blacklisted: false
  }

  state = {
    load: null,
    showModal: false
  }

  openModal = () => {
    this.setState({
      showModal: true
    })
  }

  closeModal = () => {
    this.setState({
      showModal: false
    })
  }

  handleToggle = () => {
    const {handleToggle, deal, blacklisted} = this.props
    adminTracking.changePerkVisibility(deal, blacklisted ? "show" : "hidden")
    const load = handleToggle(deal.uuid).then(() => {
      this.setState({load: null})
    })
    this.setState({load})
  }

  render() {
    const {deal, blacklisted} = this.props
    const {showModal, load} = this.state

    const isDealHeaderCropped = deal.header.length > 120

    return (
      <>
        <Flex justifyContent="space-between" alignItems="center">
          <Flex justifyContent="space-between" alignItems="center">
            <ThumbnailImage src={getThumbnailImage(deal.thumbnailImage, {grayscale: blacklisted})} />
            <StyledH5 grey={blacklisted}>
              {deal.header}
              {!isDealHeaderCropped && <StyledIconBtn icon="question" inline size={24} top={7} onClick={this.openModal} />}
            </StyledH5>
          </Flex>
          <Flex alignItems="center">
            {isDealHeaderCropped && <StyledIconBtn icon="question" inline size={24} top={4} onClick={this.openModal} />}
            <ToggleWrapper>
              <Toggle load={load} checked={!blacklisted} icons={false} onClick={this.handleToggle} />
            </ToggleWrapper>
          </Flex>
        </Flex>
        <HR />
        {showModal && <DescriptionModal onHide={this.closeModal} deal={deal} />}
      </>
    )
  }
}
